import React from "react";
import { FormControl, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import { getOptionsForSelect } from "utils/getOptionsForSelect";

/**
 * @param {{
 *  label?: string;
 *  name: string;
 *  control: any;
 *  rules?: any;
 *  size?: "small" | "medium";
 *  withNone?: boolean;
 *  [key: string]: any;
 * }} props
 */
export const FormSelectField = ({
  label,
  name,
  control,
  rules = {},
  size = "small",
  options,
  withNone = false,
  noneLabel = "",
  noneValue = "",
  doNotSortOptions = false,
  sx = { textAlign: "left" },
  ...props
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({
        field: { ref, value, ...inputProps },
        fieldState: { error },
      }) => (
        <FormControl fullWidth error={!!error}>
          <TextField
            select
            value={value ?? ""}
            size={size}
            label={label}
            error={!!error}
            helperText={error?.message}
            inputRef={ref}
            {...inputProps}
            {...props}
            variant="outlined"
            sx={sx}
          >
            {getOptionsForSelect(options, withNone, noneLabel, noneValue, doNotSortOptions)}
          </TextField>
        </FormControl>
      )}
    />
  );
};
